export default "__VITE_ASSET__s1caezJr__"